import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { IWizardImportPageComponent } from '../../models/config.model';

@Component({
    selector: 'content-page-wrapper',
    templateUrl: './content-page-wrapper.component.html',
    styleUrls: ['./content-page-wrapper.component.scss'],
    standalone: false
})
export class ContentPageWrapperComponent implements OnInit {
  @Input() component: Type<unknown>;
  @Input() transferObject: object;
  @Output() componentInstantiated = new EventEmitter<IWizardImportPageComponent>();

  @ViewChild('container', { static: true, read: ViewContainerRef })
  private contentPageContainer: ViewContainerRef | undefined;
  constructor(private resolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadContent();
  }

  private loadContent() {
    const factory = this.resolver.resolveComponentFactory(this.component);
    const componentRef = this.contentPageContainer?.createComponent(factory);
    const instance = componentRef?.instance as IWizardImportPageComponent;
    instance.transferObject = this.transferObject;
    this.componentInstantiated.emit(instance);
  }
}
